import { request as getList } from './reducers/get-list';
import { request as getSportLadder } from './reducers/getSportLadder';
import { request as updateSportLadder } from './reducers/updateSportLadder';
import { request as copySportLadder } from './reducers/copySportLadder';

import { request as getMaster } from './reducers/masterLadder/get';
import { request as createMasterLadderPrice } from './reducers/masterLadder/createPrice';
import { request as updateMasterLadderPrice } from './reducers/masterLadder/updatePrice';
import { request as deleteMasterLadderPrice } from './reducers/masterLadder/deletePrice';

// eslint-disable-next-line import/no-default-export
export default {
    LADDERS_GET_LIST_REQUEST: getList,
    LADDER_GET_REQUEST: getSportLadder,
    LADDER_UPDATE_REQUEST: updateSportLadder,
    LADDER_COPY_REQUEST: copySportLadder,

    //Master Ladder CRUD
    LADDERS_GET_MASTER_REQUEST: getMaster,
    LADDERS_CREATE_PRICE_REQUEST: createMasterLadderPrice,
    LADDERS_UPDATE_PRICE_REQUEST: updateMasterLadderPrice,
    LADDERS_DELETE_PRICE_REQUEST: deleteMasterLadderPrice,
};
